import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Timepicker = ({
	value,
	onChange,
	className,
	classNameParent,
	name,
	disabled = false,
}) => {
	return (
		<div className={`flex gap-2 ${classNameParent}`}>
			<input
				className={`h-10 border-2 focus:outline-yellow-400 rounded-md p-1 ${
					className ? className : "w-full"
				}`}
				type="time"
				disabled={disabled}
				value={value}
				onChange={onChange}
				name={name}
			/>
			{/* <DatePicker
				className={`h-10 border-2 focus:outline-yellow-400 rounded-md p-1 ${
					className ? className : "w-full"
				}`}
				selected={value}
				onChange={onChange}
				showTimeSelect
				showTimeSelectOnly
				timeIntervals={15}
				dateFormat="h:mm aa"
				name={name}
				timeCaption="Time"
			/> */}
		</div>
	);
};

export default Timepicker;
